import ReactPlayer from 'react-player/youtube';

type Props = {
    videoId: string;
}

export const EmbeddedVideo = ({ videoId }: Props) => {

    return (
        <ReactPlayer
            url={`https://www.youtube.com/watch?v=${videoId}`}
            width="100%"
        />
    )
}
